import * as Yup from "yup";

const sendingSchema = Yup
    .object()
    .shape({
        emails: Yup
            .array()
            .of(Yup.string().email())
    });

export default sendingSchema;
